// extracted by mini-css-extract-plugin
export default {"actionButton":"PortfolioWidget_actionButton__qYAIW","strategyCloseButton":"PortfolioWidget_strategyCloseButton__oeR8+"};